export default __webpack_public_path__ + "images/97fb39a3d0a6fda84c1f6eda93eebd6a.png";